var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_70_7154",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 5.97436C18.1131 5.78711 17.8595 5.68187 17.595 5.68187C17.3305 5.68187 17.0768 5.78711 16.89 5.97436L12 10.8544L7.10997 5.96436C6.92314 5.77711 6.66949 5.67188 6.40497 5.67188C6.14045 5.67188 5.8868 5.77711 5.69997 5.96436C5.30997 6.35436 5.30997 6.98436 5.69997 7.37436L10.59 12.2644L5.69997 17.1544C5.30997 17.5444 5.30997 18.1744 5.69997 18.5644C6.08997 18.9544 6.71997 18.9544 7.10997 18.5644L12 13.6744L16.89 18.5644C17.28 18.9544 17.91 18.9544 18.3 18.5644C18.69 18.1744 18.69 17.5444 18.3 17.1544L13.41 12.2644L18.3 7.37436C18.68 6.99436 18.68 6.35436 18.3 5.97436Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_70_7154)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.264648,
    width: 24,
    height: 24
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.dacaa4b621bce70f1ecd54d7852e0daa.svg";
export { ForwardRef as ReactComponent };